export default "__VITE_ASSET__08a2fba8__$_?component__"